import {
  useEffect
} from 'react';

const Ads = () => {

  const loadAdzrScript = () => {

    const adzrScript = document.createElement('script');
    adzrScript.src = 'https://adzr.vodacom.co.za/libs/netpol-gamzr/js/netpol-gamzr.min.js';
    document.head.append(adzrScript);

    adzrScript.onerror = function() {
      loadGptScript();
    };
  };

  const loadGptScript = () => {

    const gptScript = document.createElement('script');
    gptScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    document.head.append(gptScript);
  };

  const initAdsScript = () => {

    window.netpol_gamzr_appName = 'ConnectU';
    window.netpol_gamzr_appSecret = '9b3fcbce-3589-42d4-a069-4b7d5bb1d513';

    if (!window?.fetch) {
      loadGptScript();
      return;
    }

    fetch('https://adzr.vcza.smartraffic.net/ipvalidator/v1/validate?mcc=655&mnc=01')
      .then((success) => {

        if (success.status !== 200) {
          loadGptScript();
          return;
        }

        loadAdzrScript();
      })
      .catch((error) => {
        loadGptScript();
      });
  };

  useEffect(() => {
    initAdsScript();
  }, []);

  return null;
};

export default Ads;
